import React from "react"

import BaseSvgIcon from "../Base"

const LockPersonFilled = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="12 10 19 21">
      <g fill="#402aff" clipPath="url(#a)">
        <path d="M27 20c.7 0 1.37.1 2 .29V19c0-1.1-.9-2-2-2h-1v-2c0-2.76-2.24-5-5-5s-5 2.24-5 5v2h-1c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h6.26c-.79-1.13-1.26-2.51-1.26-4 0-3.87 3.13-7 7-7m-9.1-5c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2h-6.2z" />
        <path d="M27 22c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5m0 2c.83 0 1.5.67 1.5 1.5S27.83 27 27 27s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5m0 6c-1.03 0-1.94-.52-2.48-1.32.73-.42 1.57-.68 2.48-.68s1.75.26 2.48.68c-.54.8-1.45 1.32-2.48 1.32" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M9 9h24v24H9z" />
        </clipPath>
      </defs>
    </BaseSvgIcon>
  )
}

export default LockPersonFilled
